// extracted by mini-css-extract-plugin
module.exports = {"root":"Q_b","text":"Q_Q","button":"Q_bl","image":"Q_Z","dividerAnimation":"Q_p"};